let splitFract = n => n.toString().split(/\.|,/)

export default splitFract


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/splitFract.js
 **/